import { Assets } from "../../assets";
import { Container } from "../../common/components/container/Container";
import i18n from "../../i18n/i18n";
import { OperationCard } from "./components/operationCard/OperationCard";
import style from "./style.module.scss"

type OperationCardItemType = {
  title: string;
  uri: string;
  icon?: string;
};

const operationItems: Array<OperationCardItemType> = [
  {
    title: "Ops Com",
    uri: "sales-operations",
    icon: Assets.images.ships,
  },
  {
    title: "Cabotage",
    uri: "cabotage",
    icon: Assets.images.cabotage,
  },
  {
    title: "Gestion Equipe",
    uri: "team-management",
    icon: Assets.images.equipement_management,
  },
  {
    title: "Activités",
    uri: "activity",
    icon: Assets.images.tools,
  },
];
export const OperationsPage = () => {
  return (
    <div className="mt-4">
      <h4>{i18n.t("OPERATIONS_MANAGEENT")}</h4>
      <Container className={style.material_container}>
        {/* <div className="d-flex gap-4 m-5 flex-wrap"> */}
        <div className={style.type_grid}>
          {operationItems.map((item: OperationCardItemType, index: number) => (
            <OperationCard
              key={index}
              icon={item.icon}
              title={item.title}
              uri={item.uri}
            />
          ))}
        </div>
      </Container>
    </div>
  );
};
